export default __webpack_public_path__ + "static/media/RTR 200 FI_LateralIzq.c749b7d2.webp";